module.exports = __webpack_public_path__ + "static/media/Libertybusiness-geo.f3cfc145.svg";